import { styled } from "@mui/material/styles";
import Backdrop from "@mui/material/Backdrop";

const BackdropPrimaryMain = styled(Backdrop)(({ theme }) => ({
  zIndex: 2000,
  color: theme.palette.primary.main,
}));

export default BackdropPrimaryMain;
